import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BusinessInfo } from '@app/model/business-info';
import { BusinessSliderInfo } from '@app/model/business-slider-info';
import { FeedRating } from '@app/model/feedsRating';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { environment } from '../../../../environments/environment.prod';
import {Swiper} from 'swiper';
import { SafeUrl } from '@angular/platform-browser';
import { SeoService } from '@app/services/seo/seo.service';

@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.component.html',
  styleUrls: ['./business-details.component.css']
})
export class BusinessDetailsComponent implements OnInit {
  active = 1;
  businessInfo: any;
  userInfoId: any;
  businessSlug = '';
  watchers = [];
  profileBgImageURL: any;
  profileImageURL:any;
  sliderImages:any;

  feedList:any;
  feedTotal:any;
  feedAvg:any;
 
  serverImgUrl= environment.IMG_URL;
  serverUrl = environment.PRO_URL;
  isBrowser: boolean;
  
  constructor(
    private businessService: BusinessDetailsService,
    private route: ActivatedRoute, 
    private loader: LoaderService, 
    private feedsService: FeedsService,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.businessInfo = new BusinessInfo();
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const routeValue = params['uid'];
      this.businessSlug = routeValue;

      if (this.isUuid(routeValue)) {
        this.loadBusinessById(routeValue);
      } else if (routeValue) {
        this.resolveBusinessSlug(routeValue);
      }
    });

    var swiper = new Swiper(".mySwiper", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  private loadBusinessById(userInfoId: string): void {
    this.userInfoId = userInfoId;
    this.fetchBusinessById();
    this.fetchProfileBgImgById();
    this.fetchProfileImgById();
    this.fetchSliderProductById();
    this.fetchFeedsByBusinessUUID();
  }

  private resolveBusinessSlug(slug: string): void {
    slug = decodeURIComponent(slug).toLowerCase();
    this.businessService.resolveBusinessBySlug(slug).subscribe({
      next: (res: any) => {
        const business = (res?.data || []).find((item: any) => this.toSlug(item.businessName) === this.toSlug(slug));
        if (business?.userInfoId) {
          this.loadBusinessById(business.userInfoId);
        }
      }
    });
  }

  private isUuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  }

  private toSlug(value: string): string {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  fetchBusinessById(): void {
    this.loader.show();
    this.businessService.getBusinessInfoByUUId(this.userInfoId)
      .subscribe({
        next: (res:any) => {
          this.businessInfo = res as BusinessInfo;
          if (res.success!==0) {
            this.businessInfo.firstName = this.businessInfo.data[0].firstName;
            this.businessInfo.lastName = this.businessInfo.data[0].lastName;
            this.businessInfo.detailAddress = this.businessInfo.data[0].detailAddress;
            this.businessInfo.phoneNumber = this.businessInfo.data[0].phoneNumber;
            this.businessInfo.businessWebsite = this.businessInfo.data[0].businessWebsite;
            this.businessInfo.businessName = this.businessInfo.data[0].businessName;
            this.businessSlug = this.toSlug(this.businessInfo.businessName);
            this.businessInfo.businessKeywords = this.businessInfo.data[0].businessKeywords;
            this.businessInfo.categoryInfoId = this.businessInfo.data[0].categoryInfoId;
            this.businessInfo.aboutBusiness = this.businessInfo.data[0].aboutBusiness;
            this.businessInfo.businessDetails = this.businessInfo.data[0].businessDetails;
            this.updateBusinessSeo();
          }
          
          for (var i = 0; i < this.watchers.length; i++) {
            for (var j = 0; j < this.watchers.length; j++) {
                if (i !== j && this.watchers[i] === this.watchers[j]) {
                    console.log(this.watchers.length);
                }
            }
          }
          window.scroll(0, 0);
        },
        // error: (e) => {
        //   console.error('Error loading details.', e);
        // },
        // complete: () => {
        //   setTimeout(() => {
        //     this.loader.hide();

        //   }, 2000);
        //   console.log('Loaded details from the API.');
        // }
      });
  }

  fetchProfileBgImgById(): void {
    this.businessService.getProfileBgImgByUUId(this.userInfoId).subscribe({
      next: (res: any) => {
        const user = res.data.find((user: any) => user.userInfoId);
        if (user) {
          const imageURL = user.profileBgImageURL;
          this.profileBgImageURL = `${this.serverImgUrl}profiles/${imageURL}`;
        }
      },
    });
  }

  fetchProfileImgById() {
    this.businessService.getProfileImgByUUId(this.userInfoId).subscribe({
      next: (res: any) => {
        const user = res.data.find((user: any) => user.userInfoId);
        if (user) {
          const imageURL = user.profileImageURL;
          this.profileImageURL = `${this.serverImgUrl}profiles/${imageURL}`;
          this.updateBusinessSeo(this.profileImageURL);
        } else {
          this.profileImageURL = `../../assets/images/all/1.jpg`;
        }
      }
  })
  }
  
  fetchSliderProductById(): void {
    this.businessService.getSliderImageByUUId(this.userInfoId)
      .subscribe({
        next: (res:any) => {
          if (res.success !==0) {
            this.sliderImages = res as BusinessSliderInfo;
            const imageName = this.sliderImages.data?.[0]?.businessImageURL;
            if (imageName) {
              this.updateBusinessSeo(`${this.serverImgUrl}sliderImages/${imageName}`);
            }
          } else
          {
            this.sliderImages = `../../assets/images/all/1.jpg`;
          }
        }
      });
  }

  private updateBusinessSeo(image?: string): void {
    if (!this.businessInfo.businessName) {
      return;
    }
    const description = this.businessInfo.aboutBusiness || this.businessInfo.businessDetails || `Business profile for ${this.businessInfo.businessName} in Maharashtra.`;
    this.seoService.update({
      title: `${this.businessInfo.businessName} | Business Profile`,
      description: `${this.businessInfo.businessName} - ${description}`.substring(0, 160),
      keywords: this.businessInfo.businessKeywords || this.businessInfo.businessName,
      image
    });
  }
  
  // Below API return business feeds
  fetchFeedsByBusinessUUID(): void {
    this.feedsService.fetchFeedsByBusinessUUID(this.userInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0; 
          }
        }
      });
  }

  
  // Set URL for QRCODE to search product 
  qrCodeDownloadLink: SafeUrl = "";
  qrCodeString(){
    return `${this.serverUrl}/business-details/${this.businessSlug}`;
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }
  
}
